import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { convertDateTimeFromServer, convertDateTimeToServer, displayDefaultDateTime } from 'app/shared/util/date-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getSubmissionRequests } from 'app/entities/submission-request/submission-request.reducer';
import { createEntity, getEntity, reset, updateEntity } from './workflow-documents.reducer';

export const WorkflowDocumentsUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const submissionRequests = useAppSelector(state => state.submissionRequest.entities);
  const workflowDocumentsEntity = useAppSelector(state => state.workflowDocuments.entity);
  const loading = useAppSelector(state => state.workflowDocuments.loading);
  const updating = useAppSelector(state => state.workflowDocuments.updating);
  const updateSuccess = useAppSelector(state => state.workflowDocuments.updateSuccess);

  const handleClose = () => {
    navigate(`/workflow-documents${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getSubmissionRequests({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.id !== undefined && typeof values.id !== 'number') {
      values.id = Number(values.id);
    }
    if (values.workflowId !== undefined && typeof values.workflowId !== 'number') {
      values.workflowId = Number(values.workflowId);
    }
    values.uploadedAt = convertDateTimeToServer(values.uploadedAt);

    const entity = {
      ...workflowDocumentsEntity,
      ...values,
      submissionRequest: submissionRequests.find(it => it.id.toString() === values.submissionRequest?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {
          uploadedAt: displayDefaultDateTime(),
        }
      : {
          ...workflowDocumentsEntity,
          uploadedAt: convertDateTimeFromServer(workflowDocumentsEntity.uploadedAt),
          submissionRequest: workflowDocumentsEntity?.submissionRequest?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tycheApp.workflowDocuments.home.createOrEditLabel" data-cy="WorkflowDocumentsCreateUpdateHeading">
            <Translate contentKey="tycheApp.workflowDocuments.home.createOrEditLabel">Create or edit a WorkflowDocuments</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="workflow-documents-id"
                  label={translate('global.field.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tycheApp.workflowDocuments.workflowId')}
                id="workflow-documents-workflowId"
                name="workflowId"
                data-cy="workflowId"
                type="text"
              />
              <ValidatedField
                label={translate('tycheApp.workflowDocuments.name')}
                id="workflow-documents-name"
                name="name"
                data-cy="name"
                type="text"
              />
              <ValidatedField
                label={translate('tycheApp.workflowDocuments.path')}
                id="workflow-documents-path"
                name="path"
                data-cy="path"
                type="text"
              />
              <ValidatedField
                label={translate('tycheApp.workflowDocuments.uploadedAt')}
                id="workflow-documents-uploadedAt"
                name="uploadedAt"
                data-cy="uploadedAt"
                type="datetime-local"
                placeholder="YYYY-MM-DD HH:mm"
              />
              <ValidatedField
                id="workflow-documents-submissionRequest"
                name="submissionRequest"
                data-cy="submissionRequest"
                label={translate('tycheApp.workflowDocuments.submissionRequest')}
                type="select"
              >
                <option value="" key="0" />
                {submissionRequests
                  ? submissionRequests.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/workflow-documents" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default WorkflowDocumentsUpdate;
